import { useContext } from "react";
import { ActiveUsersContext, ActiveUsersContextType } from "../contexts/activeUsers";

export const useActiveUsers = (): ActiveUsersContextType => {
  return useContext(ActiveUsersContext);
};
